import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Impressum.css"; // Falls du zusätzliches Styling brauchst

const Impressum = () => {
  return (
    <div className="container">
      <div className="impressum-container">
        <h1>Impressum</h1>

        <h2>1. Angaben gemäß § 5 TMG</h2>
        <p>
          <strong>Pohlert Steinreinigung</strong><br />
          Marvin Simon Pohlert<br />
          Im Zellersgrund 11<br />
          36251 Bad Hersfeld<br />
          Tel: <a href="tel:+015754929865">+49 1575 49 29 865  </a><br />
          E-Mail: <a href="mailto:pohlertsteinreinigung@gmail.com">pohlertsteinreinigung@gmail.com</a><br></br>
          Umsatzsteuernr. : beantragt
        </p>

        <h2>2. Vertreten durch</h2>
        <p>Marvin Simon Pohlert</p>

        <h2>3. Kontakt</h2>
        <p>
          Telefon: <a href="tel:+491632055488">+49 163 2055488</a><br />
          E-Mail: <a href="mailto:pohlertsteinreinigung@gmail.com">pohlertsteinreinigung@gmail.com</a>
        </p>

        <h2>4. Umsatzsteuer-ID</h2>
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: beantragt</p>

        <h2>5. Haftung für Inhalte</h2>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
          Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
        </p>

        <h2>6. Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
          können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist
          stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>

        <h2>7. Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
          des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>

        <h2>8. Änderungen dieses Impressums</h2>
        <p>Wir behalten uns vor, dieses Impressum zu aktualisieren. Die jeweils aktuelle Version ist jederzeit auf unserer Website einsehbar.</p>

        <p>
          <strong>Letzte Aktualisierung:</strong> März 2025
        </p>

        <p>
          Fragen? Schreib uns an:{" "}
          <a href="mailto:pohlertsteinreinigung@gmail.com">pohlertsteinreinigung@gmail.com</a>
        </p>
      </div>
    </div>
  );
};

export default Impressum;
